export default [
  {
    name: 'Code',
    prop: 'code',
    type: 'text'
  },
  {
    name: 'Name',
    prop: 'name',
    type: 'text'
  },
  {
    name: 'Product',
    prop: 'product_id',
    type: 'autocomplete',
    references: 'admin/products',
    referenceProp: 'name',
    displayProp: 'long_name'
  }
]
